/* src/app/views/smart-filters/modal/smart-filter-selection-modal/smart-filter-selection-modal.component.scss */
.bs-light {
  font-family: poppins, sans-serif;
  font-weight: 300;
  font-style: normal;
}
.bs-italic {
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: italic;
}
.bs-regular {
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: normal;
}
.bs-medium {
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-style: normal;
}
.bs-medium-italic {
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-style: italic;
}
.bs-bold-italic {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: italic;
}
.bs-semi-bold {
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-style: normal;
}
.bs-semi-bold-italic {
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-style: italic;
}
.bs-bold {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: normal;
}
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
:host ::ng-deep .mat-mdc-tab-label {
  padding: 0 1rem 0 1rem;
  min-width: 0;
  margin-right: 1rem;
  font-size: 1rem;
  transition: none;
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: normal;
}
:host ::ng-deep .mat-ink-bar {
  transition: none;
}
.loading-dots-container {
  height: 100%;
  width: 100%;
}
.no-search-results-container {
  margin-top: 1.5rem;
}
/*# sourceMappingURL=smart-filter-selection-modal.component.css.map */
